<template>
    <div
      ref="sectionRef"
      :class="[
      'animated-section',
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AnimatedSection',
  props: {
    // 阈值（元素可见比例）
    threshold: {
      type: Number,
      default: 0.1
    },
    // 是否只触发一次
    once: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      isVisible: false,
      observer: null
    }
  },
  mounted() {
    this.initObserver()
  },
  beforeDestroy() {
    this.disconnectObserver()
  },
  methods: {
    initObserver() {
      // 使用Intersection Observer API检测元素是否进入视口
      this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.isVisible = true
                this.$emit('visible',this.isVisible)
                // 如果只需要触发一次，则停止观察
                if (this.once) {
                  this.disconnectObserver()
                }
              } else if (!this.once) {
                // 如果允许重复动画，离开视口时重置
                this.isVisible = false
                this.$emit('visible',this.isVisible)
              }
            })
          },
          {
            threshold: this.threshold,// 阈值（元素可见比例）
            rootMargin: '0px 0px -50px 0px' // 提前50px触发
          }
      )
      if (this.$refs.sectionRef) {
        this.observer.observe(this.$refs.sectionRef)
      }
    },

    disconnectObserver() {
      if (this.observer && this.$refs.sectionRef) {
        this.observer.unobserve(this.$refs.sectionRef)
        this.observer.disconnect()
      }
    }
  }
}
</script>

<style scoped>
.animated-section {
  will-change: transform, opacity;
}
</style>
